import { CompactText } from 'ui/CompactText';
import type React from 'react';
import { NavLink } from 'react-router';
import { Clock, GraduationCap, Wallet } from 'lucide-react';

import screen from '../ChatScreen.module.scss';
import type { ChatRole } from '../types';

const TIPS = [
  {
    icon: GraduationCap,
    title: 'Формат и опыт',
    text: 'Коротко опишите работу по нужной теме.',
  },
  {
    icon: Wallet,
    title: 'Пробный урок и цена часа',
    text: 'Назовите цену и предложите обсудить условия.',
  },
  {
    icon: Clock,
    title: 'Удобное время',
    text: 'Укажите время, когда вы готовы заниматься.',
  },
];

export const ChatEmptyState: React.FC<{ role: ChatRole }> = ({ role }) => {
  if (role === 'tutor') {
    return (
      <div className={screen.cards}>
        <section className={`${screen.card} ${screen.cardTutor}`}>
          <h2 className={screen.cardTitle}>Диалоги появятся после отклика</h2>
          <p className={screen.cardText}>
            Профиль одобрен, но отклики еще не отправлены.
          </p>
          <div className={screen.noteTutor}>
            <p className={screen.noteTitle}>Начните с подходящей заявки</p>
            <CompactText className={screen.noteText} tone={'info'}>
              В поиске посмотрите класс, цель и формат. Отклик на заявку открывает чат с учеником.
            </CompactText>
          </div>
          <NavLink to='/teacher/search' className={screen.buttonWide}>
            Перейти к поиску заявок
          </NavLink>
        </section>
        <section className={`${screen.card} ${screen.cardTutor}`}>
          <h2 className={screen.cardTitle}>Что написать первым</h2>
          <ul className={screen.tips}>
            {TIPS.map((tip) => (
              <li key={tip.title} className={screen.tip}>
                <span className={screen.tipMark} aria-hidden='true'>
                  <tip.icon size={20} />
                </span>
                <div>
                  <p className={screen.tipTitle}>{tip.title}</p>
                  <p className={screen.tipText}>{tip.text}</p>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>
    );
  }

  return (
    <section className={screen.card}>
      <h2 className={screen.cardTitle}>Пока нет диалогов</h2>
      <p className={screen.cardText}>
        Преподаватели еще не откликнулись. Начать чат можно после отклика на задачу.
      </p>
      <p className={screen.stepLabel}>Следующий шаг</p>
      <p className={screen.stepText}>Создайте задачу: цель, класс, бюджет и удобное время.</p>
      <CompactText className={screen.note} tone={'info'}>
        Не публикуйте телефон или почту в задаче. Условия сначала обсудите в чате.
      </CompactText>
      <div className={screen.actions}>
        <NavLink to='/profile/details/task' className={screen.button}>
          Создать задачу
        </NavLink>
        <NavLink to='/profile/tasks' className={screen.buttonGhost}>
          К моим задачам
        </NavLink>
      </div>
    </section>
  );
};
